import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./SocialL1.module.css";
import { SocialStore } from "./SocialStore";

function SocialL1({ distrito }) {
  const [rendaExclusiva, setRendaExclusiva] = useState(null);
  const [creditoRural, setCreditoRural] = useState(null);
  const [possuiEmpresa, setPossuiEmpresa] = useState(null);
  const [rendaExclusivaOldValue, setRendaExclusivaOldValue] = useState(null);
  const [creditoRuralOldValue, setCreditoRuralOldValue] = useState(null);
  const [possuiEmpresaOldValue, setPossuiEmpresaOldValue] = useState(null);

  const rendaExclusivaValue = SocialStore((state) => state.rendaExclusivaValue);

  const creditoRuralValue = SocialStore((state) => state.creditoRuralValue);

  const possuiEmpresaValue = SocialStore((state) => state.possuiEmpresaValue);

  const rendaPrincipalValue = SocialStore((state) => state.rendaPrincipalValue);

  const dificuldadeValue = SocialStore((state) => state.dificuldadeValue);

  const empreendedorismoValue = SocialStore(
    (state) => state.empreendedorismoValue
  );

  const recebeRecursosValue = SocialStore((state) => state.recebeRecursosValue);

  const atividadeRuralValue = SocialStore((state) => state.atividadeRuralValue);

  const setRendaExclusivaValue = SocialStore(
    (state) => state.setRendaExclusivaValue
  );

  const setCreditoRuralValue = SocialStore(
    (state) => state.setCreditoRuralValue
  );

  const setPossuiEmpresaValue = SocialStore(
    (state) => state.setPossuiEmpresaValue
  );

  const setRendaExclusivaImage = SocialStore(
    (state) => state.setRendaExclusivaImage
  );

  const setCreditoRuralImage = SocialStore(
    (state) => state.setCreditoRuralImage
  );

  const setPossuiEmpresaImage = SocialStore(
    (state) => state.setPossuiEmpresaImage
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [rendaExclusiva, creditoRural, possuiEmpresa] = await Promise.all(
          [
            Api.getRendaExclusiva(
              distrito,
              null,
              creditoRuralValue,
              possuiEmpresaValue,
              rendaPrincipalValue,
              dificuldadeValue,
              empreendedorismoValue,
              recebeRecursosValue,
              atividadeRuralValue
            ),
            Api.getCreditoRural(
              distrito,
              rendaExclusivaValue,
              null,
              possuiEmpresaValue,
              rendaPrincipalValue,
              dificuldadeValue,
              empreendedorismoValue,
              recebeRecursosValue,
              atividadeRuralValue
            ),
            Api.getPossuiEmpresa(
              distrito,
              rendaExclusivaValue,
              creditoRuralValue,
              null,
              rendaPrincipalValue,
              dificuldadeValue,
              empreendedorismoValue,
              recebeRecursosValue,
              atividadeRuralValue
            ),
          ]
        );
        setRendaExclusiva(Functions.buildSmallPieGraphParams(rendaExclusiva));
        setCreditoRural(Functions.buildSmallPieGraphParams(creditoRural));
        setPossuiEmpresa(Functions.buildSmallPieGraphParams(possuiEmpresa));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [
    distrito,
    rendaExclusivaValue,
    creditoRuralValue,
    possuiEmpresaValue,
    rendaPrincipalValue,
    dificuldadeValue,
    empreendedorismoValue,
    recebeRecursosValue,
    atividadeRuralValue,
  ]);

  const onRendaExclusivaClick = (value) => {
    setRendaExclusivaValue(value);
  };

  const onCreditoRuralClick = (value) => {
    setCreditoRuralValue(value);
  };

  const onPossuiEmpresaClick = (value) => {
    setPossuiEmpresaValue(value);
  };

  return (
    <div className={styles.socialL1}>
      <div className={styles.smallPiegraph}>
        {rendaExclusiva && (
          <SmallPieGraph
            data={rendaExclusiva}
            text="RENDA EXCLUSIVA"
            onLegendClick={onRendaExclusivaClick}
            currentValue={rendaExclusivaValue}
            oldValue={rendaExclusivaOldValue}
            onOldValue={setRendaExclusivaOldValue}
            onImageReady={setRendaExclusivaImage}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {creditoRural && (
          <SmallPieGraph
            data={creditoRural}
            text="CRÉDITO RURAL"
            onLegendClick={onCreditoRuralClick}
            currentValue={creditoRuralValue}
            oldValue={creditoRuralOldValue}
            onOldValue={setCreditoRuralOldValue}
            onImageReady={setCreditoRuralImage}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {possuiEmpresa && (
          <SmallPieGraph
            data={possuiEmpresa}
            text="POSSUI EMPRESA"
            onLegendClick={onPossuiEmpresaClick}
            currentValue={possuiEmpresaValue}
            oldValue={possuiEmpresaOldValue}
            onOldValue={setPossuiEmpresaOldValue}
            onImageReady={setPossuiEmpresaImage}
          />
        )}
      </div>
    </div>
  );
}

export default SocialL1;
